export default "__VITE_ASSET__57eff592__"